import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Card from "../../components/common/Card";
import Button from "../../components/common/Button";
import { logout } from "../../store/authSlice";

const NotAuthorized = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/pos", { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 px-4 py-10 dark:from-slate-950 dark:via-slate-900 dark:to-slate-800">
      <Card className="w-full max-w-xl space-y-6 border border-rose-200/70 bg-white/95 shadow-2xl dark:border-rose-900/40 dark:bg-slate-900/90">
        <div className="space-y-2">
          <div className="inline-flex rounded-full bg-rose-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-rose-700 dark:bg-rose-950/40 dark:text-rose-300">
            Not Authorized
          </div>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
            You do not have access to this feature.
          </h1>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            You do not have access to this feature. If you think this is a
            mistake, contact an admin.
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          <Button onClick={handleGoBack}>Close</Button>
          <Button
            variant="secondary"
            onClick={() => {
              dispatch(logout());
              navigate("/login", { replace: true });
            }}
          >
            Sign Out
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default NotAuthorized;
